import { render, staticRenderFns } from "./DeleteAction.vue?vue&type=template&id=0b07e1e8&"
import script from "./DeleteAction.vue?vue&type=script&lang=ts&"
export * from "./DeleteAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports